const PushStatuses = {
    1: "Not sent",
    2: "Sent",
    3: "Error"    
};
Object.freeze(PushStatuses);

export { PushStatuses }